import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";
import { Location } from "history";

import { fetchUser } from "actions/user";
import { fetchLocations } from "actions/account";
import { initFeatureFlags } from "actions/context";
import { IRootStateProps } from "types/reducers";

import MicroApp from "components/micro_app";

interface IPropsFromState {
  email: IRootStateProps["user"]["email"];
  firstName: string;
  lastName: string;
  currentLocation: Location;
}

interface IMapDispatchToProps {
  fetchUser: () => void;
  fetchLocations: (permalink: string) => void;
  initFeatureFlags: (permalink: string, email: string) => void;
}

const mapStateToProps = (
  state: IRootStateProps,
  ownProps: RouteComponentProps
): IPropsFromState => {
  const { email, firstName, lastName } = state.user;
  const first = firstName.unwrapOr("");
  const last = lastName.unwrapOr("");
  return {
    email,
    firstName: first,
    lastName: last,
    currentLocation: ownProps.location,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  fetchUser,
  fetchLocations,
  initFeatureFlags,
};

const MicroAppContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MicroApp)
);

export default MicroAppContainer;
